import React from 'react';
import classNames from "classnames";
import ReactLoading from 'react-loading';

const BroadcastFilterList = (props) => {

    let liveNowLeftNavParent = classNames({ 'highlight': true, 'active': props.leftNavParentIndex === 0 && props.sort_by === "all"}),
        popularityLeftNavParent = classNames({'highlight': true, 'active': props.sort_by === "history"}),
        mostViewsLeftNavParent = classNames({'highlight': true, 'active': props.sort_by === "subscriptions"}),
        availabilityFilterLeftNavParent = classNames({'highlight': true, 'active': props.sort_by === "purchase"});

    return (
        <ul className="left-nav">
            <li className={liveNowLeftNavParent} id="leftNavLiveNow">
                <a href="javascript:void(0);"
                   onClick={props.clickedOnSortByFilter("all",false)}>
                    <div className="left">All</div>
                    <div className="right">{
                        props.get_content_list && props.get_content_list.isFetching ?
                            <ReactLoading type={"bubbles"} color={"#1b75bc"} width={20} height={19}/>
                            :
                            props.sort_by === "all" && props.liveNowCount
                    }</div>
                </a>
            </li>
            <li className={popularityLeftNavParent}>
                <a href="javascript:void(0);"
                   onClick={props.clickedOnSortByFilter("history")}>
                    <div className="left">History</div>
                    <div className="right">{
                        props.get_content_list && props.get_content_list.isFetching ?
                            <ReactLoading type={"bubbles"} color={"#1b75bc"} width={20} height={19}/>
                            :
                            props.sort_by === "history" && props.liveNowCount
                    }</div>
                </a>
            </li>
            <li className={mostViewsLeftNavParent}>
                <a href="javascript:void(0);"
                   onClick={props.clickedOnSortByFilter("subscriptions")}>
                    <div className="left">Subscriptions</div>
                    <div className="right">{
                        props.get_content_list && props.get_content_list.isFetching ?
                            <ReactLoading type={"bubbles"} color={"#1b75bc"} width={20} height={19}/>
                            :
                            props.sort_by === "subscriptions" && props.liveNowCount
                    }</div>
                </a>
            </li>
            <li className={availabilityFilterLeftNavParent}>
                <a href="javascript:void(0);" onClick={props.clickedOnSortByFilter("purchase")}>
                    <div className="left">Purchased</div>
                    <div className="right">{
                        props.get_content_list && props.get_content_list.isFetching ?
                            <ReactLoading type={"bubbles"} color={"#1b75bc"} width={20} height={19}/>
                            :
                            props.sort_by === "purchase" && props.liveNowCount
                    }</div>
                </a>
            </li>
        </ul>
    )
}

export default BroadcastFilterList;